import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css';
import './fonts.css'
import './index.css'
import App from './App.tsx'
import AuthProvider from './context/AuthProvider'
import ReportProvider from './context/ReportProvider';
import { GenieProvider } from './context/GenieProvider';
import { ReportStateProvider } from './context/ReportStateProvider';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ReportProvider>
          <ReportStateProvider>
            <GenieProvider>
              <App />
            </GenieProvider>
          </ReportStateProvider>
        </ReportProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
)
